import axios from "axios";

export default axios.create({
  baseURL: "https://admin.pitafreshflorida.com/api/",
});
